export default __webpack_public_path__ + "static/media/phantom-bg.fbe8b0dd.png";